import styled from '@emotion/styled';
import Box from './layouts/Box';
import { oneOfType, string, func, node } from 'prop-types';

const ExternalLink = styled(Box)(({ textDecoration }) => ({ textDecoration }));

ExternalLink.propTypes = {
  href: string.isRequired,
  color: string,
  textDecoration: string,
  onClick: func,
  children: oneOfType([string, node]),
};

ExternalLink.defaultProps = {
  as: 'a',
  color: 'primary',
  textDecoration: 'underline',
  onClick: () => {},
  target: '_blank',
  rel: 'noopener noreferer',
};

export default ExternalLink;
